<template>
    <div class="agree-box">
        <el-dialog title :visible.sync="pop_show" class="agree-pop" v-if="pop_show" :close-on-click-modal="false">
            <div class="close" @click="closePop()"></div>
            <div class="title">零玖电竞使用协议</div>
            <base-divider></base-divider>
            <div class="agree-content">
                <div class="inst-word">
                    <p class="tite">特别提示 :</p>
                    <p class="height">
                        本协议由您与零玖电竞应用程序（以下简称&quot;零玖电竞&quot; ）运营方上海四游网络科技有限公司（以下简称&quot;四游网络&quot;）共同缔结，本协议具有合同效力。
                        <span>在下载零玖电竞和/或使用零玖电竞之前，请先仔细阅读本《零玖电竞使用协议》，特别是字体加粗、颜色标记的内容。</span>
                    </p>
                    <p class="height">
                        四游网络根据以下服务条款为您提供服务。四游网络有权根据需要不时地制订、修改本协议及/或任何有关指引或规则，并同意按照本协议的规定以及不时发布的操作规则提供基于互联网以及移动网的相关服务（以下称"网络服务"），变更后的协议和有关规则公布（包括网页公告、电子邮件、站内信、APP/小程序推送的通知等，下同）后，在公告明确的特定时间自动生效。前述所有的指引和规则，均构成本使用协议的一部分。您在使用四游网络提供的各项服务之前，应仔细阅读本使用协议。
                        <span>如您不同意本使用协议及/或随时对其进行的修改，请您立即停止使用零玖电竞应用程序所提供的全部服务；您一旦使用，即视为您已了解并完全同意本使用协议各项内容，包括四游网络对使用协议随时所做的任何修改。此后，您不得以未阅读本使用协议内容作任何形式的抗辩。</span>
                    </p>
                    <p class="tite">1.服务说明</p>
                    <p class="height">
                        1.1 为了您能正常使用四游网络提供的服务，您同意以下事项：依本协议项下服务注册提示，请您
                        <span>填写正确的用户名，注册手机号码/邮箱和密码，并确保今后更新的邮箱、名号、手机号码等资料的有效性和合法性。</span>若您提供任何违法、危害国家安全或网络安全、不道德、损害他人合法权益或四游网络认为不适合在零玖电竞上展示的资料，或者四游网络有理由怀疑您的资料属于程序或恶意操作，四游网络有权暂停或终止您的账号，并拒绝您于现在和未来使用本协议项下服务之全部或任何部分。
                    </p>
                    <p class="height">1.2 您点击&ldquo;接受&rdquo;或&ldquo;同意&rdquo;按钮按钮并按注册程序成功注册后，您的行为就已表示您无条件接受并遵守本协议条款以及四游网络不时公布的各项“其他公开规则”，包括但不限于：《用户条例》以及其他官方通知。</p>
                    <p class="height">
                        1.3 注册成功后，四游网络将给予您一个账号及相应的密码，该用户账号和密码由您负责保管。保护您的账号安全，是您的责任。您应对所有使用您的密码及账号的活动负完全的责任。
                        <span>您同意：1）如果您未保管好自己的账号和密码，因此而产生的任何损失或损害，四游网络无法也不承担任何责任；2）您要对您账号中的所有活动和事件负全责。如果您未保管好自己的账号和/或密码而对您、四游网络或第三方造成的损害，您将负全部责任。</span>
                    </p>
                    <p
                        class="height red"
                    >1.4 四游网络采取合理的方式提请您注意的义务将通过如下方式实现：在本协议中以明确的足以引起您注意的加粗字体、颜色标记等合理方式提醒您注意相关条款（需要强调的是，还包括您应特别注意任何未明确标记的含有“不承担”、“免责”“不得”等形式用语的条款），该等条款的确认将导致您在特定情况下的被动、不便、损失，请您在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《中华人民共和国民法典》第497条规定的“不合理地免除或者减轻其责任、加重对方责任、限制对方主要权利，排除对方主要权利的”的条款。鉴于四游网络已依法明确了上述条款、履行了格式条款制订方的义务，您点击“同意”或“下一步”，将被视为且应当被视为您已经完全注意并同意了本协议所有条款。您不应当以四游网络未对格式条款以合理方式提醒您注意，或未根据您要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款不成为本协议的内容、非法或无效。</p>
                    <p
                        class="height bottom red"
                    >1.5 如您有任何需要说明条款的要求，请您立即停止使用零玖电竞的服务并按四游网络公布的联系方式与四游网络取得联系，提出需要说明条款的要求。若您未致电或发送有说明条款要求的邮件至四游网络而选择同意该协议，则双方在此确认四游网络已依法履行了根据您要求对相关条款进行说明的法定义务，四游网络已给予您充足的时间与充分的选择权来决定是否缔结本协议。</p>
                    <p class="tite">2.服务内容</p>
                    <p class="height">2.1 本协议项下服务的具体内容由四游网络根据实际情况提供，包括但不仅限于零玖电竞、聊天室、电子邮件等。</p>
                    <p class="height">2.2 四游网络提供的部分网络服务为收费的网络服务，若您使用收费网络服务则需要向四游网络支付一定的服务费用。对于收费的网络服务，四游网络会在您使用之前给予您明确的提示，只有您根据提示确认并愿意支付相关费用，才能使用该收费网络服务。若拒绝支付相关费用，则不可享受该收费网络服务。</p>
                    <p class="height bottom">2.3 您同意并理解，四游网络仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由您自行负担。</p>
                    <p class="tite">3.使用规则</p>
                    <p class="height">
                        3.1
                        <span>您承诺遵守国家有关实名制的规定和要求，以您真实身份注册成为四游网络的用户，并保证所提供的个人资料信息真实、准确、完整、有效，并依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。</span>您以其真实身份注册成为四游网络用户后，需要修改所提供的个人身份资料信息或注销账号的，应向四游网络说明理由并提供相应的真实、准确、完整、有效的资料信息，四游网络审查（但不代表四游网络对您的资料信息提供任何形式的担保或保证，下同）后及时为您提供修改或注销服务。
                    </p>
                    <p class="height">3.2 四游网络有权审查您注册所提供的身份信息是否真实、准确、完整、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；您仍有义务妥善保管您的账号及密码，并正确、安全地使用您的账号及密码。</p>
                    <p class="height">3.3 您对包括您在内的任何人使用您的账户和密码登录后所持账号产生的行为依法享有权利和承担责任。</p>
                    <p class="height">
                        3.4
                        <span>您在注册和使用的零玖电竞时，应遵守《互联网用户账号名称管理规定》第六条之规定，即：任何机构或个人注册和使用的互联网用户账号名称，不得有下列情形：</span>
                    </p>
                    <p class="height indent">
                        <span>（一）违反宪法或法律法规规定的；</span>
                    </p>
                    <p class="height indent">
                        <span>（二）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
                    </p>
                    <p class="height indent">
                        <span>（三）损害国家荣誉和利益的，损害公共利益的；</span>
                    </p>
                    <p class="height indent">
                        <span>（四）煽动民族仇恨、民族歧视，破坏民族团结的；</span>
                    </p>
                    <p class="height indent">
                        <span>（五）破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
                    </p>
                    <p class="height indent">
                        <span>（六）散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
                    </p>
                    <p class="height indent">
                        <span>（七）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
                    </p>
                    <p class="height indent">
                        <span>（八）侮辱或者诽谤他人，侵害他人合法权益的；</span>
                    </p>
                    <p class="height indent">
                        <span>（九）含有法律、行政法规禁止的其他内容的。</span>
                    </p>
                    <p class="height">
                        <span>注册和使用的互联网用户账号名称也不得含有违背社会公德、公序良俗，宣扬恐怖主义、极端主义，扰乱经济秩序或社会秩序的虚假信息，以及侵害他人名誉、隐私、知识产权等内容。</span>
                    </p>
                    <p class="height">如有上述情形之一的，四游网络有权拒绝您注册和使用，要求您更换符合规定的其他用户名进行注册和使用。</p>
                    <p
                        class="height"
                    >3.5 您如发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据四游网络公布的处理方式通知四游网络。四游网络根据您的通知采取措施暂停用户账号的登录和使用的，将要求您提供与您注册身份信息相一致的个人有效身份信息并核实。四游网络核实您所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停您所通知账号的登录和使用。您没有提供您个人有效身份证件或者您提供的个人有效身份证件与所注册的身份信息不一致的，四游网络有权拒绝您的上述请求。</p>
                    <p class="height">3.6 用户同意接受四游网络通过电子邮件或其他方式向用户发送 您不应将您的账号、密码转让、出租或出借予他人使用，否则由此产生的一切后果和责任均应由您完全承担。如您发现您的账号遭他人非法使用，应立即通知四游网络。因黑客行为等不可抗力因素或您保管疏忽导致账号、密码遭他人非法使用，四游网络不承担任何责任。</p>
                    <p
                        class="height"
                    >3.7 您同意接受四游网络通过电子邮件或其他方式向您发送商品促销或其他相关商业信息。该等商品促销或商业信息是由广告商或商业服务提供者提供并承担相应责任，四游网络仅提供发布信息的媒介。您通过该等链接的网站或广告所购买的商品或服务，其交易行为仅存在于您与该商品或服务的提供者之间，与四游网络无关，四游网络不就您与该商品或服务的提供者之间所产生的交易行为承担任何法律责任，您应予以特别留意。</p>
                    <p
                        class="height"
                    >3.8 您对于您创作并通过本协议项下服务上传到四游网络网站上的内容（但内容违反法律法规，或不受《著作权法》或其他法律法规保护的内容除外，下同）依法享有版权及其他相关合法权利。对于您通过本协议项下服务上传到四游网站上可公开获取区域的任何内容，您同意四游网络在全世界范围内具有免费的、永久性的、不可撤销的权利和许可，以使用、复制、修改、改编、汇编、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分）。</p>
                    <p class="height">3.9 如您在使用网络服务时违反本协议项下的任何规定，四游网络或其授权的人有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您发布的内容等、暂停或终止您使用本协议项下服务的权利）以减轻您的不当行为造成的影响。</p>
                    <p class="height">3.10 四游网络针对某些特定的服务的使用通过各种方式（包括但不限于网页公告、电子邮件、短信提醒等）做出的任何声明、通知、警示等内容视为本协议的一部分，您如使用本协议项下服务，视为您同意该等声明、通知、警示的内容。</p>
                    <p class="height">
                        3.11
                        <span>您输入的姓名和身份证号码结合与之对应的证件，作为您使用本协议项下服务的唯一有效身份证明；在您无法有效证明您的身份时，四游网络有权拒绝向您提供任何信息与服务或承担任何义务或责任。</span>
                    </p>
                    <p class="height">
                        3.12
                        <span>您通过本协议项下服务对相关程序、软件的使用受制于某些已经包含在程序、软件规则中的行为准则。这些规则经四游网络公布并不定期更新，如您继续通过本协议项下服务使用相关程序、软件的，则必须遵守。您有义务知晓、了解并遵守这些行为规则。四游网络保留权利决定何种行为违反游戏精神，并对该等行为采取其认为合适的相应的处理措施（包括但不限于警告、倒扣数值、暂时或永久冻结账号、拒绝提供服务等）。四游网络保留不定期修改这些行为规则的权利。</span>
                    </p>
                    <p class="height">3.13 四游网络有权不定期修改本协议的任何条款，一旦本协议的内容发生变动，四游网络将会通过相关方式提示修改内容。修改后的使用协议一旦公布即有效代替原来的使用协议。用户可随时造访https://www.09game.com查阅最新用户协议。</p>
                    <p class="height">3.14 若您是未成年人，在决定注册零玖电竞账号、使用本协议项下服务之前，您应该和您父母或者监护人一起阅读本协议，以确保他们理解并同意本协议的内容。在未获得父母或者监护人的同意之前，您不得使用本协议项下服务。使用本协议项下服务即表示：您声明并保证已满18岁或者18岁以上；或您已经获得父母或者监护人的允许使用。</p>
                    <p
                        class="height bottom"
                    >3.15 若您是未成年人，也应遵守国家有关网络游戏用户账号实名注册和登录要求，以真实身份信息注册和登录零玖电竞账号、使用本协议项下服务。四游网络将遵守国家相关规定，仅在周五、周六、周日和法定节假日每日20时至21时向您提供1小时服务，如因此导致您在其他时间段无法登录零玖电竞账号或使用本协议项下服务的，四游网络不承担任何责任。如您未遵守相关实名制要求的（包括借用、冒用、盗用成年人身份信息注册零玖电竞账号，借用、冒用、盗用成年人已有的零玖电竞账号等），四游网络或其授权的人有权要求您改正或直接采取一切必要的措施（包括但不限于限制账号登录、冻结账号、暂停或终止您使用本协议项下服务的权利等）。四游网络同时建议父母和监护人在未成年人使用网络、移动手机和其它设备的时候进行监督和指导。</p>
                    <p class="tite">4.用户行为</p>
                    <p class="height">您在使用零玖电竞时，必须遵循以下规则：</p>
                    <p class="height">4.1 遵守中国有关的法律和法规；</p>
                    <p class="height">4.2 遵守所有与网络服务有关的网络协议、规定和程序；</p>
                    <p class="height">4.3 不得为任何非法目的而使用零玖电竞；</p>
                    <p class="height">4.4 不得以任何形式使用零玖电竞服务侵犯四游网络或第三方的商业利益或其他合法权益；</p>
                    <p class="height">4.5 不得利用零玖电竞服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；</p>
                    <p class="height">4.6 不得利用零玖电竞提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</p>
                    <p class="height">4.7 不得利用零玖电竞服务系统进行任何不利于零玖电竞的行为；四游网络有权对用户使用零玖电竞服务的情况进行审查和监督，如用户在使用零玖电竞服务时违反任何上述规定，四游网络或其授权的人有权要求您改正或直接采取一切必要的措施以减轻您的不当行为造成的影响。</p>
                    <p class="height">
                        4.8
                        <span>在您同意接受本协议全部条款的前提下，四游网络同意授予您非商业使用性质的、可撤销的、可变更的、非专有的、不可转让和不可转授权的使用本协议项下服务的权利，且该等授权仅限于对个人的使用许可。未经四游网络同意，您在零玖电竞的账号及在该账号项下获取的任何权益/利益（包含程序和软件内的道具、资源、游戏代币等，下同）不得出租、出借、转让、赠与、继承或实施其他形式的处分。</span>
                    </p>
                    <p
                        class="height bottom"
                    >4.9 您知悉并同意，您注册的账号、昵称、所建立的组织名称中不允许出现包括但不限于涉及种族/宗教、国家政治、国家领导人、淫秽的/粗俗的、诽谤/恐吓、宗教或宗教人物、工作人员、攻击性的、污辱性的、可能引起误会的、违禁药品等内容的名称。如若发现前述情形，四游网络有权要求您限期改正或直接采取一切必要的措施（包括进行随机改名、暂停或终止您在本协议项下的全部或部分服务等）。</p>
                    <p class="tite">5.服务变更、中断或终止</p>
                    <p
                        class="height"
                    >5.1 鉴于网络服务的特殊性，您同意四游网络有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。如变更、中断或终止的网络服务属于免费网络服务，四游网络无需通知，也无需对您或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费网络服务，四游网络应当在变更、中断或终止之前事先通知您，如您因此受到不利影响的，四游网络应向您提供等值的替代性的收费网络服务，如您不愿意接受替代性的收费网络服务，就您已经向四游网络支付的服务费，四游网络应当按照您实际使用相应收费网络服务的情况扣除相应服务费之后，将剩余的服务费退还给您。</p>
                    <p class="height">5.2 您理解，为了更好的提供本协议项下服务，四游网络需要定期或不定期地对提供网络服务的零玖电竞（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成免费网络服务或收费网络服务在合理时间内的中断，四游网络无需为此承担任何责任，但四游网络将尽可能事先进行通告。</p>
                    <p class="height">
                        5.3 您理解，对本协议项下服务的各个程序、软件新版本，四游网络可以自行决定保留为本协议项下服务增加附加特点和功能，或者提供程序编程之修补、更新和升级的权利；对此，
                        <span>四游网络无需向您发出通知即可自行决定修改、停止或暂停您对任何程序、软件版本服务的使用，以便对相关程序、软件进行检修、改良和/或升级或者出于其他合理原因；对于因修改、停止或暂停任何程序、软件版本，发行和/或不发行任何程序、软件的新版本而导致的直接或间接损害，四游网络将不承担任何赔偿责任。</span>
                    </p>
                    <p class="height">
                        5.4
                        <span>您有如下任何一种或多种行为的，四游网络有权随时终止或暂停对您在本协议项下的全部或部分服务（包括但不限于封停该用户账号）或取消您的账号，并且有权随时取消或收回您在该账号项下获取的任何权益/利益，而无需对用户或任何第三方承担任何责任：</span>
                    </p>
                    <p class="height indent">
                        <span>5.4.1 您提供的个人资料不真实、不准确、不完整；</span>
                    </p>
                    <p class="height indent">
                        <span>5.4.2 您违反本协议中规定的使用规则或者其他各项公开规则（包括《封号规则》、《隐私政策》、《社区使用协议》、《用户条例》以及其他官方通知）的行为；</span>
                    </p>
                    <p class="height indent">
                        <span>5.4.3 您在使用收费网络服务时未按规定向四游网络支付相应的服务费；</span>
                    </p>
                    <p class="height indent">
                        <span>5.4.4 您注册的账号自注册起30天内或连续180天，没有使用过该账号（包括使用该账号登录游戏、登录网站、充值），则四游网络有权删除该账号，包括但不限于注册信息、等级信息、物品信息等一切与该注册账号相关的信息；</span>
                    </p>
                    <p class="height indent">
                        <span>5.4.5 您注册的账号实施了违反法律法规，损害国家、第三方或四游网络合法权益的行为。</span>
                    </p>
                    <p class="height">5.5 如您有发布违法信息、严重违背社会公德、以及实施其他违反法律禁止性规定的行为，四游网络有权立即终止对您提供服务。</p>
                    <p class="height">5.6 您在接受四游网络提供服务时实施法律法规规定或本协议项下的不正当行为的，四游网络有权终止对您提供的服务。</p>
                    <p class="height">5.7 如您提供虚假注册身份信息（包括借用、冒用、盗用他人身份信息），或实施违反本协议的行为，四游网络有权中止对您提供全部或部分服务；四游网络采取中止措施应当通知用户并告知中止期间，中止期间届满如您已完全纠正所实施的违反本协议的行为并赔偿相关方所受到的损失的，四游网络应当及时恢复对您的服务，否则四游网络有权终止对您的服务。</p>
                    <p class="height">
                        5.8
                        <span>除本协议另有规定外，您若反对、不接受任何本协议条款或对本协议所作的条款修改有异议，或对本协议项下服务不满，您只有以下的追索权：</span>
                    </p>
                    <p class="height indent">5.8.1 不再使用本协议项下服务。</p>
                    <p class="height indent">5.8.2 结束使用本协议项下服务的资格。</p>
                    <p class="height indent">5.8.3 通告本站停止对您的服务。</p>
                    <p class="height">
                        <span>结束本协议项下服务后，您使用本协议项下服务的权利及因此包含的任何权益/利益立即终止。从那时起，四游网络不再对您承担任何义务和/或责任。</span>
                    </p>
                    <p class="height">5.9 您应确实遵守本协议条款及有关法律命令的规定。四游网络有权出于遵守法律法规、维护互联网安全和秩序、保障其他用户的合法权益对您是否违反本协议条款作出判断。若四游网络判断您违反本协议条款或任何法律法规，您同意四游网络可以随时终止您账号的使用。</p>
                    <p class="height">5.10 如因本协议项下服务范围之外且不在四游网络控制范围内的以下情形，导致您不能使用本协议项下服务，四游网络不因此对任何损害或赔偿负责。这些情形包括但不局限于下列情况：</p>
                    <p class="height indent">5.10.1 四游网络由于执行计划中的维修工作或者更新软件或硬件而中断本协议项下服务；</p>
                    <p class="height indent">5.10.2 由于网络运营商系统故障或者网络连接故障造成的数据传送中断；</p>
                    <p class="height indent">5.10.3 由不可抗力，例如台风、地震、停电、洪水、战争或者恐怖袭击、黑客攻击而造成本协议项下服务中断；</p>
                    <p class="height indent">5.10.4 由于第三方支付服务故障所引起的本协议项下服务功能故障；</p>
                    <p class="height indent">5.10.5 由于虚拟和数字产品及增值服务供应商或者供应商停止运营而引起本协议项下服务中断；</p>
                    <p class="height indent bottom">5.10.6 由恶意软件、拒绝服务或者其它类型的黑客攻击而造成的系统服务中断。</p>
                    <p class="tite">6.虚拟物品（道具、资源等）</p>
                    <p class="height">6.1 您通过零玖电竞购买或取得（包括购买或取得方式、购买或取得渠道、资金来源等）的虚拟物品（包括道具、资源等）若有任何违反国家法律法规、本协议条款或侵犯任何第三方的合法权益的情形时，零玖电竞有权并可以暂停或终止向您提供道具、资源相关服务。</p>
                    <p class="height">
                        6.2
                        <span>为了维护用户的权益，提升用户体验，零玖电竞可以对道具、资源等的表现形式进行优化调整，对于表现形式不合理、太久远的道具、资源及效果进行删除，且不会进行额外追溯补偿。</span>
                    </p>
                    <p class="height">6.3 "零玖电竞"关于道具、资源、代币描述中，如使用*N天，均表示该数量的道具、资源、代币有效期为N天，并不表示连续N天发放该数量道具、资源、代币。</p>
                    <p class="height bottom">6.4 您购买或使用道具、资源等即代表接受本条相关约定。</p>
                    <p class="tite">7.充值提示</p>
                    <p class="height">7.1 每1元人民币可充值10酒币。四游网络有权决定本协议项下服务的收费方式和资费标准，且四游网络有权根据需要对资费政策随时进行调整。</p>
                    <p class="height">7.2 请确认充值账号登录或输入正确，一旦充值成功，系统将不提供退款、修正服务。</p>
                    <p class="height">7.3 充值成功的酒币，可以兑换零玖电竞提供的付费服务。</p>
                    <p class="height bottom">7.4 您知悉并同意，四游网络无需提前告知便可决定增加或者删除任何一种支付充值渠道。您同意遵守上述支付充值渠道规定并且遵守其用户使用协议。您应仔细地阅读上述支付充值渠道的隐私保护政策。如果您不熟悉或者不同意为您提供服务的支付充值渠道的政策，应该停止使用服务。</p>
                    <p class="tite">8.知识产权条款</p>
                    <p class="height">
                        8.1 四游网络提供的程序、软件及网络服务中包含的任何文本、图片、图形、Logo、音频和/或视频资料等均受版权、商标和/或其它知识产权及财产所有权法律的保护，未经四游网络或相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写、改编、复制或再发行，或者被用于其他任何商业目的。否则，四游网络有权追究其法律责任。
                        <span>四游网络不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式向您或任何第三方负责。</span>
                    </p>
                    <p
                        class="height"
                    >8.2 四游网络为提供本协议项下服务而使用的任何程序、软件（包括但不限于软件中所含的任何图象、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该等程序、软件的著作权人，未经该等程序、软件的著作权人许可，您不得：（1）对该程序、软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）；（2）公开展示和以各种形式、在各种平台（包括但不限于网络直播平台、网站、APP等）播放该程序、软件的全部或部分内容；（3）出租、销售该程序、软件或者利用该程序、软件从事任何营利行为；（4）修改或遮盖该程序、软件、图像、动画、包装和手册等内容上的服务名称、公司标志、商标（或）版权信息、其他知识产权声明等内容。</p>
                    <p class="height bottom">8.3 本协议项下服务可能涉及第三方知识产权，如该等第三方对用户在本协议项下服务中使用该等知识产权有要求的，则您应当遵守该等要求。</p>
                    <p class="tite">9.用户隐私保护政策</p>
                    <p class="height">
                        9.1 您知悉并同意，为便于向用户提供更好的服务，在您使用零玖电竞服务时，服务器会自动记录一些信息，包括但不限于URL、IP地址、浏览器类型、使用语言、访问日期和时间等。
                        <span>您知悉并同意，四游网络为履行包括实名制在内的法律法规规定的义务，收集、储存、使用、传输及提供您在接受本协议项下服务过程中所形成的个人信息（包括姓名、出生日期、身份证件号码、电话号码、电子邮箱等）。</span>
                    </p>
                    <p class="height">9.2 保护用户隐私是四游网络的一项基本政策，未经用户许可四游网络不会向任何第三方提供、公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式等个人身份信息，但下列情况除外：</p>
                    <p class="height indent">9.2.1 用户或用户监护人授权甲方披露的；</p>
                    <p class="height indent">9.2.2 有关法律法规要求四游网络披露的；</p>
                    <p class="height indent">9.2.3 司法机关或行政机关基于法定程序要求四游网络提供的；</p>
                    <p class="height indent">9.2.4 用户为了维护自己合法权益而向四游网络提起诉讼或者仲裁时；</p>
                    <p class="height indent">9.2.5 应用户监护人的合法要求而提供用户个人身份信息时；</p>
                    <p class="height indent">9.2.6 为维护社会公共利益的。</p>
                    <p class="height">9.3 在不透露单个用户个人信息或隐私资料的前提下，四游网络有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。尽管四游网络对用户的个人信息及隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的个人信息等不受任何形式的损失。</p>
                    <p class="height">9.4 您知悉并同意，为了向您提供服务，四游网络可能会收集有关服务性能、您的计算机和您的服务使用情况的特定信息和数据，并可能会自动从您的计算机中上载此信息和数据。该等信息和数据不会标识您的个人身份。</p>
                    <p class="height">9.5 在您使用本协议项下服务过程中产生并储存于四游网络服务器中的任何账号数据信息（包括但不限于用户个人身份数据信息等），属于零玖电竞程序和软件的一部分，由四游网络所有并进行管理。</p>
                    <p class="height bottom">
                        9.6
                        <span>如您不同意本条规定的任何一项内容的，应立即停止使用本协议项下的全部服务；您一旦使用本协议项下的服务，即视为您已了解并完全同意本条规定的内容。</span>
                    </p>
                    <p class="tite">10.免责声明</p>
                    <p class="height">
                        10.1
                        <span>您明确同意，您使用本协议项下服务所存在的风险将完全由您自行承担；因您使用本协议项下服务而产生的一切后果也由您自行承担，四游网络对您不承担任何责任。因用户擅自交易账号导致的纠纷，四游网络不承担任何责任。</span>
                    </p>
                    <p class="height">
                        10.2
                        <span>四游网络不承诺或担保网络服务一定能满足您的要求，也不承诺或担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作承诺或担保。</span>
                    </p>
                    <p class="height">
                        10.3
                        <span>四游网络不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由四游网络实际控制的任何网页上的内容，四游网络不承担任何责任。</span>
                    </p>
                    <p class="height">
                        10.4
                        <span>对于因不可抗力或四游网络不能控制的原因造成的网络服务中断或其它缺陷，四游网络不承担任何责任，但将尽力减少因此而给您造成的损失和影响。</span>
                    </p>
                    <p class="height">
                        10.5
                        <span>您同意，对于四游网络向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，四游网络无需承担任何责任：</span>
                    </p>
                    <p class="height indent">10.5.1 四游网络向用户免费提供的各项网络服务；</p>
                    <p class="height indent">10.5.2 四游网络向用户赠送的任何产品或者服务；</p>
                    <p class="height indent">10.5.3 四游网络向收费网络服务用户附赠的各种产品或者服务。</p>
                    <p class="height">
                        10.6
                        <span>对本协议项下服务中免费供用户使用的部分，您承认并同意四游网络、其关联方、其许可人及四游网络员工无须承担由于您使用本协议项下服务中免费供用户使用的部分而产生或引发的任何责任。对于本协议项下服务中免费供用户使用的部分存在的任何问题或任何不满，您唯一的权利及补救措施就是立即卸载并停止使用零玖电竞及附带相关软件。</span>
                    </p>
                    <p class="height">
                        10.7
                        <span>在任何情况下，即使四游网络、其关联方、其许可人或四游网络员工事先知道下述损失的可能性，四游网络、其关联方、其许可人或四游网络员工都无须在合同、保证、侵权（包括过失）、产品责任或其他任何形式的责任方面，为由于使用或无法使用本协议项下服务而产生的任何间接的、偶然的、特殊的或必然的损失（包括但不限于任何数据的损坏或丢失、服务的中断、计算机无法操作或金钱上的损失）负责。</span>
                    </p>
                    <p class="height">
                        10.8
                        <span>在适用法律允许的最大范围内，四游网络明确表示不提供任何其他类型的承诺、保证或担保，不论是明示的或默示的，包括但不限于适销性、适用性、可靠性、准确性、完整性、无病毒以及无错误的任何默示保证和责任。</span>
                    </p>
                    <p class="height">
                        10.9
                        <span>您知悉并同意：通过本协议项下服务所取得的任何信息、资料，是否信任及使用，完全取决于您自己，并由您承担由该等信任及使用带来的系统受损、资料丢失以及其它任何风险。四游网络对在本协议项下服务中提及的任何第三方发出的信息，都不作担保。</span>
                    </p>
                    <p class="height">
                        10.10
                        <span>四游网络对本协议项下涉及的境内外基础电信运营商的固定及移动通信网络的故障，各类技术缺陷、覆盖范围限制、不可抗力、计算机病毒、黑客攻击、用户所在位置、用户关机、合作方因素、他人故意或过失行为或其他非四游网络技术能力范围内的原因造成的服务中断、用户发送的数据或短信息的内容丢失、出现乱码、错误接收、无法接收、迟延接收等等，均不承担责任。</span>
                    </p>
                    <p class="height bottom">
                        10.11
                        <span>由于您个人失误、错误或不当操作导致的任何后果，由您自行承担责任，四游网络不予任何赔偿或补偿。</span>
                    </p>
                    <p class="tite">11.违约赔偿</p>
                    <p class="height">
                        11.1
                        <span>除本协议另有规定外，如因四游网络故意或重大过失违反有关法律法规或本协议项下的任何条款而给用户造成损失，四游网络同意承担由此造成的损害赔偿责任。</span>
                    </p>
                    <p class="height bottom">11.2 您同意保障和维护四游网络及其他用户的利益，如因您违反有关法律、法规或本协议项下的任何条款而给四游网络或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。</p>
                    <p class="tite">12.通知送达</p>
                    <p class="height">
                        12.1
                        <span>本协议项下四游网络对于用户所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</span>
                    </p>
                    <p class="height bottom">12.2 用户对于四游网络的通知应当通过四游网络对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
                    <p class="tite">13.法律适用、管辖与其他</p>
                    <p class="height">13.1 本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律，如无相关法律规定的，则应参照通用国际商业惯例和/或行业惯例</p>
                    <p class="height">13.2 四游网络于用户过失或违约时放弃本协议规定的权利的，不得视为其对用户其他或以后同类之过失或违约行为弃权。</p>
                    <p class="height">
                        13.3
                        <span>若您、四游网络或第三方之间发生任何纠纷或争议，各方首先应友好协商解决；协商不成的，各方均同意将纠纷或争议提交四游网络所在地的人民法院管辖。</span>
                    </p>
                    <p class="height">13.4 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
                    <p class="height bottom">13.5 为避免争议，本协议涉及到的有关数据、有关技术方面的问题，您同意以零玖电竞服务器所储存的数据作为判断标准。四游网络保证该数据的真实性。</p>
                    <p class="height">
                        <span>您承诺，签订本协议完全是您的自愿行为和真实意思表示；您已仔细阅读了本协议的条款，充分理解条款的含义，协议条款不存在任何误解或显失公平的情形，同意并接受上述条款。</span>
                    </p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'base-agree',
    props: {},
    created() {},
    data() {
        return {
            pop_show: false,
        }
    },
    methods: {
        // emitter: function (user_id) {
        //     console.log(user_id);
        //     this.$emit('click', user_id)
        // },
        openPop() {
            this.pop_show = true
        },
        closePop() {
            this.pop_show = false
        },
    },
}
</script>
<style  lang="scss">
.agree-pop {
    .el-dialog {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        margin-top: 0 !important;
        background: transparent !important;
        border-radius: 0;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;

        .el-form {
            padding-right: 80px;
        }

        .el-dialog__header {
            padding: 0;
            margin: 0;
            // display: none;
            .el-dialog__title {
                font-size: 16px;
            }
            .el-dialog__headerbtn .el-dialog__close {
                font-size: 16px !important;
            }
        }
        .el-dialog__body {
            padding: 0;
            margin: 0;
            box-shadow: none;
            -webkit-box-shadow: none;
            width: 100%;
            height: 100%;
        }

        .el-dialog__footer {
            padding: 0;
            margin: 0;
        }
    }
}
</style>
<style lang="scss" scoped>
.agree-box {
    .agree-pop {
        width: 6.24rem;
        height: 7.84rem;
        background: #ffffff;
        border-radius: 0.3rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .close {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            width: 0.56rem;
            height: 0.56rem;
            background: url(~@/assets/img/close.png) 0 0 no-repeat;
            background-size: 100% auto;
            &:hover {
                cursor: pointer;
                background-position-y: -0.56rem;
            }
        }
        .title {
            width: 100%;
            font-size: 0.4rem;
            text-align: center;
            height: 1.2rem;
            font-weight: bold;
            line-height: 1.25rem;
            color: #c39b5e;
        }
        .agree-content {
            width: 100%;
            height: 6.2rem;
            overflow-x: hidden;
            position: relative;
        }
        .inst-word {
            width: 100%;
            height: auto;
            padding: 0 .2rem 0 .3rem;
            position: absolute;
            top: 0;
            left: 0;
            .tite {
                color: #c39b5e;
                font-size: 0.28rem;
                font-weight: bold;
                padding: 0.15rem 0;
            }
            .height {
                color: #4a4a4a;
                line-height: 0.34rem;
                font-size: 0.22rem;
                font-weight: normal;
                margin-bottom: 0.08rem;
                span{
                    font-weight: bold;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/BaseAgree.vue